import {
  AutoComplete,
  Avatar,
  Button,
  Drawer,
  Form,
  Input,
  Select,
  Spin,
  Switch,
} from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import {
  getPage,
  getParamValue,
  jcTypeArray,
  checkStatesAndPushToHistory,
} from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import TopHeading from "./TopHeading";
import { EditOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import Empty from "../common/Empty";
import BrandDetails from "./BrandDetails";
import AddBrand from "./AddBrand";
import { responseNotification } from "../../utils/notify";
import debounce from "lodash";
import usePrevious from "../../hooks/PreviousState";
const { Option } = Select;

const BrandsList = () => {
  const router = useLocation();
  const history = useHistory();
  const [visible, setVisible] = useState(undefined);
  const [visiblePopconfirm, setVisiblePopconfirm] = useState(undefined);
  const [selectedBrand, setSelectedBrand] = useState(undefined);
  const [selectedBrandForEdit, setSelectedBrandForEdit] = useState(undefined);

  const [key, setKey] = useState(getParamValue(router.search, "key"));
  const [status, setStatus] = useState("");
  const [type, setType] = useState(
    getParamValue(router.search, "key") || "JC_MART"
  );
  const [limit, setLimit] = useState(16);
  const [brandData, setBrandData] = useState({
    loading: false,
    data: null,
  });

  const [brandOptions, setBrandOptions] = useState({
    loading: false,
    list: null,
  });

  const [confirmLoading, setConfirmLoading] = useState(false);

  const fetchRef = useRef(null);

  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const isDeleted = "false";
  const reseAllFieldData = () => {
    setStatus("");
    setKey("");
    setType("");
    form.resetFields();
    history.replace(router.pathname);
    window.location.reload();
  };

  // const handleChangeStatus = (value: string) => {
  //   setStatus(value);
  // };

  const previousType = usePrevious(type);
  const previousKey = usePrevious(key);

  window.onbeforeunload = () => {
    saveCurrentStatesInLocalStorage();
  };

  function checkLocalStorageAndSetParams() {
    var retrievedObject = JSON.parse(localStorage.getItem("rememberBrandList"));
    console.log("rememberBrandList: ", retrievedObject);

    if (retrievedObject.mobileNumber) setKey(retrievedObject.key);
    if (retrievedObject.type) setType(retrievedObject.type);
  }
  const saveCurrentStatesInLocalStorage = () => {
    localStorage.setItem(
      "rememberBrandList",
      JSON.stringify({
        key: key,
        type: type,
        page: page,
      })
    );
  };

  const getBrand = useCallback(async () => {
    let pageReseted = false;
    if (localStorage.getItem("rememberBrandList") != null) {
      checkLocalStorageAndSetParams();
      localStorage.removeItem("rememberBrandList");
    } else {
      pageReseted = checkStatesAndPushToHistory(
        [previousKey, previousType],
        [key, type],
        ["key", "type"],
        history
      );
    }
    setBrandData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/admin/brand` +
          (type ? `?type=${type}` : ``) +
          (key ? `&key=${key}` : ``) +
          (status ? `&isActive=${status}` : ``) +
          (isDeleted ? `&deleted=${isDeleted}` : ``) +
          (page ? `&page=${pageReseted ? 0 : page || 0}` : ``) +
          (limit ? `&limit=${limit}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setBrandData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setBrandData({ loading: false, data: [] });
        console.error("Brand: Error", err);
      });
  }, [limit, status, page, type, key, isDeleted]);

  useEffect(() => {
    getBrand();
  }, [getBrand]);

  const getBrandOptions = useCallback(
    async (key) => {
      setBrandOptions({ loading: true, list: null });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      axios
        .get(
          `${encodedUri}/brand/search?` +
            (key ? `&key=${key}` : ``) +
            `&page=${page || 0}` +
            `&limit=${limit || 16}`,
          // (type ? `&type=${type}` : ``) +
          // (status ? `&status=${status}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setBrandOptions({
            loading: false,
            list: res.data?.brands?.map((brand: any) => ({
              label: brand.name,
              value: brand.name,
            })),
          });
        })
        .catch((err) => {
          setBrandOptions({ loading: false, list: [] });
          console.error("Categories: Error", err);
        });
    },
    [status]
  );

  // const getBrandOptionsDebounce = (mobileNumber) => {
  //   const fetcher = (mobileNumber) => {
  //     getBrandOptions(mobileNumber);
  //   };

  //   return debounce(fetcher, 0.8);
  // };

  const getBrandOptionsDebounce = React.useMemo(() => {
    const loadOptions = (value: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setBrandOptions({ loading: false, list: null });

      if (fetchId !== fetchRef.current) {
        return;
      }

      getBrandOptions(value);
    };

    return debounce(loadOptions);
  }, []);

  const showPopconfirm = (id: any) => {
    setVisiblePopconfirm(id);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setVisible(undefined);
    setVisiblePopconfirm(undefined);
  };

  //
  const onStatusChange = async (id, val: any) => {
    setConfirmLoading(true);
    if (id) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/brand`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          isActive: val,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setConfirmLoading(undefined);
          if (res.statusCode === 200) {
            responseNotification("Status Changed Successfully", "success");
            getBrand();
            setVisible(false);
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  //
  const onDelete = async (id) => {
    setConfirmLoading(true);
    if (id) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/brand`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          deleted: true,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setConfirmLoading(undefined);
          if (res.statusCode === 200) {
            responseNotification("Brand Deleted Successfully", "success");
            setVisible(undefined);
            setVisiblePopconfirm(false);
            getBrand();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  //

  useEffect(() => {
    if (visible) {
      setSelectedBrand(undefined);
      setSelectedBrandForEdit(undefined);
    }
  }, [selectedBrand, selectedBrandForEdit]);

  useEffect(() => {
    setSelectedBrand(undefined);
    setSelectedBrandForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setSelectedBrand(null);
    setSelectedBrandForEdit(null);
    getBrand();
  };

  console.log(visiblePopconfirm);

  return (
    <React.Fragment>
      <TopHeading total={brandData?.data?.totalElements} refetch={getBrand} />
      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item initialValue={type}>
            <Select
              placeholder="Product Type"
              onChange={(val) => setType(val)}
              value={type}
              style={{ minWidth: 300 }}
            >
              {Object.values(jcTypeArray)?.map((type, i) => (
                <Option value={type} key={i}>
                  {type?.replace("_", " ")}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="search" initialValue={key}>
            <AutoComplete
              onSearch={getBrandOptions}
              onSelect={(val) => setKey(val.toString())}
              options={brandOptions?.list}
              defaultActiveFirstOption={false}
              notFoundContent={
                brandOptions?.loading ? <Spin size="small" /> : null
              }
              style={{ width: 300 }}
            >
              <Input.Search
                size="large"
                placeholder="Search by Name"
                onSearch={(val) => setKey(val)}
                enterButton
                loading={brandOptions.loading}
                maxLength={11}
              />
            </AutoComplete>
          </Form.Item>

          <Form.Item initialValue={null}>
            <Select
              placeholder="Status"
              onChange={(val) => setStatus(val)}
              value={status}
            >
              <Option value={""}>ALL</Option>
              <Option value={"true"}>ACTIVE</Option>
              <Option value={"false"}>INACTIVE</Option>
            </Select>
          </Form.Item>
        </Form>
        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Brand Name</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Type</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {brandData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {brandData?.data?.brands?.length ? (
                    brandData?.data?.brands?.map((brand: any, index: any) => (
                      <React.Fragment key={index}>
                        {/* <Link to={`/users/${user?.id}`}> */}
                        <div
                          className="single-product-wrapper"
                          onClick={() => setSelectedBrand(brand)}
                        >
                          <div className="single-product">
                            <Avatar
                              shape="square"
                              size={45}
                              src={brand?.logo}
                              className="mr-3"
                            />
                            <span className="name">{brand?.name}</span>
                          </div>
                          <div className="single-product">
                            <span className="name">
                              {brand?.type?.split("_").join(" ")}
                            </span>
                          </div>
                          <div className="single-product">
                            <Switch
                              checkedChildren={<CheckOutlined />}
                              unCheckedChildren={<CloseOutlined />}
                              defaultChecked={brand?.isActive}
                              onChange={(val, e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                onStatusChange(brand?.id, val);
                              }}
                              loading={
                                confirmLoading && brand?.id === confirmLoading
                              }
                            />
                          </div>
                          <div className="single-product">
                            <button
                              className="btn btn-sm btn-warning mx-1"
                              onClick={() => setSelectedBrandForEdit(brand)}
                            >
                              <EditOutlined />
                            </button>

                            {/* <Popconfirm
                              placement="left"
                              title="Are you sure to delete?"
                              visible={brand?.id === visiblePopconfirm}
                              onConfirm={(e) => {
                                console.log(true);
                                e.preventDefault();
                                e.stopPropagation();
                                onDelete(brand?.id);
                              }}
                              okButtonProps={{ loading: confirmLoading }}
                              onCancel={handleCancel}
                            >
                              <button
                                className="btn btn-sm btn-danger mx-1"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  showPopconfirm(brand?.id);
                                }}
                              >
                                <DeleteOutlined />
                              </button>
                            </Popconfirm> */}
                          </div>
                        </div>
                        {/* </Link> */}
                      </React.Fragment>
                    ))
                  ) : (
                    <Empty data="brands" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Drawer
            title={selectedBrandForEdit ? "Edit Brand" : "Brand Details"}
            width={500}
            onClose={() => {
              setSelectedBrand(null);
              setSelectedBrandForEdit(null);
            }}
            visible={selectedBrand || selectedBrandForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            {selectedBrandForEdit ? (
              <AddBrand
                visibleData={selectedBrandForEdit}
                onCloseMethod={onClose}
              />
            ) : (
              <BrandDetails BrandDetails={selectedBrand} />
            )}
          </Drawer>

          <PaginationTwo
            {...brandData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default BrandsList;
